// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"82a81578","168":"2c0f11d5","243":"6fab9d8a","417":"b7212ad7","471":"66d919ef","501":"80676e1f","554":"87973bd9","677":"7cfcaa49","685":"3e7ae62f"}[chunkId] + ".chunk.js";
};